import { Injectable } from '@angular/core';
import { UserSessionStoreService } from '@drl/core/store/user-session-store.service';
import { BehaviorSubject } from 'rxjs';

export interface LoaderState {
  loading: boolean;
  message?: string;
}

@Injectable({
  providedIn: 'root'
})
export class LenangioLogoLoaderService {

  private loaderSubject = new BehaviorSubject<LoaderState>({ loading: false, message: '' });
  loader$ = this.loaderSubject.asObservable();
  constructor(    private readonly store: UserSessionStoreService,
  ) {
  }

  show(state: { message?: string } = {}) {
    this.store.setLenagioLoader(true);
    this.loaderSubject.next({ loading: true, message: state.message || 'Loading...' });
  }

  hide() {
    this.loaderSubject.next({ loading: false, message: '' });
  }
  clearData(){
    this.store.setLenagioLoader(false);
  }
}
